export default __webpack_public_path__ + "static/media/Chekout-Empty.550afa54.png";